module.exports = __webpack_public_path__ + "static/mirror_of_life_trapping-2865981ac5e00327be0367c2be7addc1.jpeg";